import { render, staticRenderFns } from "./ModalApproved.vue?vue&type=template&id=084af88e&"
import script from "./ModalApproved.vue?vue&type=script&lang=ts&"
export * from "./ModalApproved.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports